import api from '../../utils/api'

import { useEffect, useState } from 'react'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormColorType from './Form/FormColorType'

function EditColorType({id , btCancelAction, handleOnSuccess}){
    const [colorType, setColorType] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()

    useEffect(() => {

        api.get(`/colorType/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {

            setColorType(response.data.colorType)
        })
    }, [token, id])

    async function updateColorType(colorType) {
        let msgType = 'success'


        const data = await api.patch(`colorType/update/${colorType._id}`, colorType, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            }

    }


    return (
        colorType.name && (
            <FormColorType title="Editar Tipo de Cor" handleSubmit={updateColorType} btnText="Salvar" btCancelAction={btCancelAction} colorTypeData={colorType} />
        )
    )
}

export default EditColorType
